var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((Object.keys(this.list)),function(label){return _c('ingredientList',{key:label,attrs:{"title":label,"groceries":_vm.list[label]}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }